import React from 'react';
export function Footer() {
  return <footer className="bg-[#0a0a0a] border-t border-[#c9a961]/20 py-8 px-4 text-center" data-id="element-152">
      <div className="max-w-3xl mx-auto" data-id="element-153">
        <div className="inline-flex items-center gap-2 text-[#c9a961] font-black text-xl mb-4" data-id="element-154">
          <span data-id="element-155">🤖</span> TU MANUAL DIGITAL™
        </div>

        <p className="text-[#e8dfd0] mb-6 max-w-md mx-auto font-medium" data-id="element-156">
          El sistema de marketing N°1 para emprendedoras de servicios en
          Argentina.
        </p>

        <div className="flex flex-col items-center gap-2 text-sm text-[#6b5d4f] mb-8 font-bold" data-id="element-157">
          <a href="mailto:soporte.tumanualdigital@gmail.com" className="hover:text-[#c9a961] transition-colors" data-id="element-158">
            📧 soporte.tumanualdigital@gmail.com
          </a>
          <a href="https://www.tumanualdigital.com" target="_blank" rel="noopener noreferrer" className="hover:text-[#c9a961] transition-colors" data-id="element-159">
            🌐 www.tumanualdigital.com
          </a>
        </div>

        <div className="text-xs text-[#6b5d4f] space-y-2 font-medium" data-id="element-160">
          <p data-id="element-161">© Tu Manual Digital™ · Todos los derechos reservados</p>
          <p className="italic" data-id="element-162">"El próximo domingo puede ser diferente." 🤖</p>
        </div>
      </div>
    </footer>;
}